import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Users, Zap } from 'lucide-react';
import { Button } from './ui/Button';
import { BackgroundEffects } from './ui/BackgroundEffects';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-16 pb-16 overflow-hidden" data-id="element-57">
      <BackgroundEffects data-id="element-58" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-59">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-60">
          <motion.div className="inline-block mb-5 px-4 py-1.5 rounded-full border border-[#fbbf24]/30 bg-[#fbbf24]/10 text-[#fbbf24] text-xs sm:text-sm font-medium tracking-widest uppercase" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2
        }} data-id="element-61">
            Transformación Espiritual Profunda
          </motion.div>

          {/* Title */}
          <motion.h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight uppercase tracking-tight" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-62">
            <span className="text-white drop-shadow-lg" data-id="element-63">DESBLOQUEÁ TU </span>
            <span className="text-gold-gradient drop-shadow-[0_0_30px_rgba(251,191,36,0.3)]" data-id="element-64">
              ENERGÍA
            </span>
            <span className="text-white drop-shadow-lg" data-id="element-65"> Y COMENZÁ TU </span>
            <span className="text-gold-gradient drop-shadow-[0_0_30px_rgba(251,191,36,0.3)]" data-id="element-66">
              TRANSFORMACIÓN ESPIRITUAL
            </span>
            <span className="text-white drop-shadow-lg" data-id="element-67"> EN SOLO </span>
            <span className="text-gold-gradient drop-shadow-[0_0_30px_rgba(251,191,36,0.3)]" data-id="element-68">
              48H
            </span>
          </motion.h1>

          {/* Mockup Image BETWEEN title and subtitle */}
          <motion.div className="relative w-full max-w-md md:max-w-lg my-2" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-69">
            <div className="absolute inset-0 bg-[#7c3aed] rounded-full mix-blend-screen filter blur-[100px] opacity-30 animate-pulse-slow" data-id="element-70" />
            <motion.img src="https://cdn.magicpatterns.com/uploads/9i1jfPJww31HhAnrAcMGgo/Untitled_design_(1).png" alt="Energia Cuantica PRO KIT" className="w-full h-auto object-contain relative z-10 drop-shadow-[0_0_50px_rgba(124,58,237,0.4)]" animate={{
            y: [-8, 8, -8]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-71" />
          </motion.div>

          {/* Subtitle */}
          <motion.p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl font-light leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.4
        }} data-id="element-72">
            El sistema completo para desbloquear tu energía, transformar tu
            vibración y crear una nueva realidad desde la consciencia cuántica.
          </motion.p>

          {/* CTA */}
          <motion.div className="flex flex-col items-center gap-5" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.5
        }} data-id="element-73">
            <Button size="xl" className="w-full sm:w-auto" href="https://checkout.tusbeneficios.shop/cart/51012899700969:1" data-id="element-74">
              QUIERO ACCEDER AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-5 text-sm text-white/60" data-id="element-75">
              <div className="flex items-center gap-2" data-id="element-76">
                <Zap className="w-4 h-4 text-[#fbbf24]" data-id="element-77" />
                <span data-id="element-78">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-79">
                <Shield className="w-4 h-4 text-[#fbbf24]" data-id="element-80" />
                <span data-id="element-81">Garantía 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-82">
                <Users className="w-4 h-4 text-[#fbbf24]" data-id="element-83" />
                <span data-id="element-84">+10,000 Estudiantes</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}